import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationRouteNames } from '@core/presentation';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.page.html',
  styleUrls: ['./thank-you.page.scss'],
})
export class ThankYouPage {
  constructor(private router: Router) {}

  onLoginClick() {
    this.router.navigate(['/authentication', AuthenticationRouteNames.signIn]);
  }
}
